<template>
	<div class="col-12">
		<div class="row"> 
			<div class="col-12">
				<div class="desglose-titulo">{{ getTitulo }}</div>
				<div :class="desglose == 0 ? 'text-center desglose activo' : 'text-center desglose'" v-on:click="seleccionaDesglose(0)">General</div>
				<div :class="desglose == 1 ? 'text-center desglose activo' : 'text-center desglose'" v-on:click="seleccionaDesglose(1)">Ordenes<br/>facturadas</div>
				<div :class="desglose == 2 ? 'text-center desglose activo' : 'text-center desglose'" v-on:click="seleccionaDesglose(2)">Ordenes<br/>por Facturar</div>
				<div :class="desglose == 3 ? 'text-center desglose activo' : 'text-center desglose'" v-on:click="seleccionaDesglose(3)">Ordenes NC<br/>Realizadas</div>
				<div :class="desglose == 4 ? 'text-center desglose activo' : 'text-center desglose'" v-on:click="seleccionaDesglose(4)">Ordenes NC<br/>por Realizar</div>
			</div>
		</div>
		<div class="row"> 
			<div class="col-12">
				<iframe :src="getData" class="frame" id="frame" :key="'frame_' + info + '_' + periodo"></iframe>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	export default
	{
		name: "Detalle",
		props: {
			info: String,
		},
		data() {
			return {
				periodo: "",
				desglose: 0,
				vistas: {
					desglose: [ "052ad0c0-612f-11e9-9d22-8bb331243d10", "bcd5dfe0-61ec-11e9-9d22-8bb331243d10", "356c1fe0-61ee-11e9-9d22-8bb331243d10", "28ec2cd0-61f1-11e9-9d22-    8bb331243d10", "a577a330-61ef-11e9-9d22-8bb331243d10" ],
					internacionales: [ "39a1a7b0-61f8-11e9-9d22-8bb331243d10", "17f98410-61f9-11e9-9d22-8bb331243d10", "9d017460-61f9-11e9-9d22-8bb331243d10", "fa553570-61f9-11e9-9d22-8bb331243d10", "7fa55250-61fa-11e9-9d22-8bb331243d10" ],
					normales: [ "1076ba20-61fc-11e9-9d22-8bb331243d10", "94656050-61fe-11e9-9d22-8bb331243d10", "e41f8850-61fe-11e9-9d22-8bb331243d10", "36a4b730-61ff-11e9-9d22-8bb331243d10", "8fbbe000-61ff-11e9-9d22-8bb331243d10" ],
					on_receipt: [ "2e494080-6202-11e9-9d22-8bb331243d10", "5a183d40-6204-11e9-9d22-8bb331243d10", "a92b76e0-6204-11e9-9d22-8bb331243d10", "02087ce0-6205-11e9-9d22-8bb331243d10", "51e5e450-6205-11e9-9d22-8bb331243d10" ],
					por_resolver: [ "dc59da40-6207-11e9-9d22-8bb331243d10", "7fc25590-620d-11e9-9d22-8bb331243d10", "dc2bddb0-620d-11e9-9d22-8bb331243d10", "2f1832d0-620e-11e9-9d22-8bb331243d10", "7fbb3430-620e-11e9-9d22-8bb331243d10" ]
				}
			}
		},
		created() {

			this.periodo = this.$periodo
		},
		mounted: function() {

			const that = this

			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})
		},
		computed: {

			getTitulo() {

				var titulo = this.info.charAt(0).toUpperCase() + this.info.slice(1).replace("_", " ")
				return titulo
			},

			getData() {

				return this.getURL()
			}
		},
		methods: {

			// Metodo que obtiene la URL para actualizar el IFRAME
			getURL() {

				var tmp = this.periodo.split("-")

				var finicio = this.periodo.substr(0, 7) + "-01"
				var fecha = new Date(tmp[0], tmp[1], 0)
				var ffinal = this.periodo.substr(0, 7) + "-" + fecha.getDate()

				var vista = this.vistas[this.info][this.desglose]
				var src = this.$api + "/kibana/app/dashboards#/view/" + vista + "?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'" + finicio + "T00%3A00%3A00.000Z'%2Cmode%3Aquick%2Cto%3A'" + ffinal + "T23%3A59%3A59.999Z'))"


				return src
			},

			// Metodo que controla el desglose seleccionado
			seleccionaDesglose(value) {

				// Guardamos la opcion seleccionada
				this.desglose = value
			},
		}
	}
</script>
<style scoped>

     .desglose-titulo {
		height: 60px;
		float: left;
		padding: 5px 10px 5px 10px;
		background-color: #337ab7;
		border-radius: 4px;
		color: white;
		font-weight: bold;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.desglose {
		height: 60px;
		float: left;
		padding: 5px 10px 5px 10px;
		background-color: #A0A0A0;
		border-radius: 4px;
		color: white;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.desglose-cerrar {
		float: right
	}

	.desglose-cerrar:hover {
		cursor: pointer;
	}

	.desglose:not(.desglose-activo):hover {
		opacity: 0.8;
		cursor: pointer;
	}

	.activo {
		background-color: lightgray;
		color: black;
	}

	.frame {
		width: 100%;
		height: 800px;
		border-left: 0px;
		border-right: 0px;
		border-bottom: 0px;
		border-top: 2px solid lightgray;
	}

</style>
